import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=5c925f22&scoped=true&"
import script from "./side-nav.vue?vue&type=script&lang=ts&"
export * from "./side-nav.vue?vue&type=script&lang=ts&"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=5c925f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c925f22",
  null
  
)

export default component.exports